export default __webpack_public_path__ + "static/media/exercise.1dd4b967.svg";